import React, { useEffect, useState, useCallback } from "react";
import { TABLE_HEADERS } from "../constants";
import { getRequestForApproval, getRequestForApprovalWithStatus } from "@api";
import DataTable from "react-data-table-component";
import {
  Box,
  Grid,
  Button,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { Search } from "@components/table/toolbar/search-filters";
import { useHistory } from "react-router-dom";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";
import { Form, Modal as ConfirmModal } from "@components";
import { approveRequest, bulkRejectRequest } from "@api";
import { alertService } from "@services";

interface CommentInfo {
  comment: string;
  commentReject: string;
}

type Key = keyof CommentInfo;

const columns = [
  {
    name: TABLE_HEADERS.REF_NUMBER,
    selector: "referenceNumber",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.EFFECTIVE_DATE,
    selector: "effectiveDate",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.REQUEST_TYPE,
    selector: "requestType",
    sortable: true,
  },
  // {
  //   name: TABLE_HEADERS.REQUESTOR,
  //   selector: "requestor",
  //   sortable: true,
  // },
  {
    name: TABLE_HEADERS.USER,
    selector: "userName",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.SYSTEM_CATEGORY,
    selector: "category",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.DEVICE_TYPE,
    selector: "deviceType",
    sortable: true,
  },
  {
    name: TABLE_HEADERS.NAME,
    selector: "subCategory",
    sortable: true,
  },
  // {
  //   name: TABLE_HEADERS.ENVIRONMENT,
  //   selector: "environment",
  //   sortable: true,
  // },
  // {
  //   name: TABLE_HEADERS.ROLE,
  //   selector: "roleName",
  //   sortable: true,
  // },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

const LinearIndeterminate = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress />
    </div>
  );
};

export const ApproveRequest: React.FC = () => {
  const history = useHistory();
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [page, setPage] = React.useState<number>(1);
  const [perPage, setPerPage] = React.useState<number>(10);
  const [total, setTotal] = React.useState<number>(0);
  const [searchQuery, setSearchQuery] = React.useState<string>("");
  const [forApprovals, setForApprovals] = useState<[]>([]);
  const [sortBy, setSortBy] = useState("" || "desc");
  const [sortItem, setSortItem] = useState("" || "dateAdded");
  const [openApprove, setOpenApprove] = useState<boolean>(false);
  const [openReject, setOpenReject] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [requestStatus, setRequestStatus] = useState<string>(
    "APPROVAL IN-PROGRESS"
  );
  const [resetPaginationPage, setResetPaginationPage] = useState<boolean>(
    false
  );
  const handleSort = (column: any, sortDirection: any) => {
    setSortItem(column.selector);
    setSortBy(sortDirection);
  };

  useEffect(() => {
    fetchForApprovals();
  }, [history, sortBy, sortItem, page, perPage, searchQuery, requestStatus]);

  useEffect(() => {
    setPage(1);
    setResetPaginationPage(!resetPaginationPage);
    //setTotal(0);
  }, [perPage, searchQuery, requestStatus]);
  /*
  function fetchForApprovals() {
    setIsloading(true);
    getRequestForApproval(page, perPage, searchQuery, sortItem, sortBy)
      .then((req: any) => {
        setForApprovals(req.requests);
        setTotal(req.totalRequests);
        setClearSelectedRows(!clearSelectedRows);
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setIsloading(false);
      });
  }
  */
  function fetchForApprovals() {
    setIsloading(true);
    getRequestForApprovalWithStatus(
      page,
      perPage,
      searchQuery,
      sortItem,
      sortBy,
      requestStatus
    )
      .then((req: any) => {
        setForApprovals(req.requests);
        setTotal(req.totalRequests);
        setClearSelectedRows(!clearSelectedRows);
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setIsloading(false);
      });
  }

  const form = Form.useManager<CommentInfo>({
    comment: "",
    commentReject: "",
  });

  const onSubmitApproval = () => {
    let ids: number[] = [];
    console.log(selectedRows);
    selectedRows.forEach((d: any) => {
      ids = [...ids, d.id];
    });
    if (selectedRows.length > 0) {
    }
    setIsSubmitting(true);
    approveRequest(ids, form.values.comment)
      .then((response) => {
        alertService.success({ msg: "Successfully approved!" });
        clearAndClose();
        fetchForApprovals();
      })
      .catch((error) => {
        if (error.response.status) {
          alertService.danger({
            msg: "Failed to approve.",
            statusCode: error.response.status,
          });
        }
      })
      .then(() => {
        setIsSubmitting(false);
      });
  };

  const onSubmitReject = () => {
    let ids: number[] = [];
    console.log(selectedRows);
    selectedRows.forEach((d: any) => {
      ids = [...ids, d.id];
    });

    if (!form.values.commentReject) {
      alertService.danger({
        msg: "Please add comment(s).",
      });
      return;
    }
    setIsSubmitting(true);
    bulkRejectRequest(ids, form.values.commentReject)
      .then((response) => {
        alertService.success({ msg: "Successfully rejected!" });
        clearAndClose();
        fetchForApprovals();
      })
      .catch((error) => {
        if (error.response.status) {
          alertService.danger({
            msg: "Failed to reject.",
            statusCode: error.response.status,
          });
        }
      })
      .then(() => {
        setIsSubmitting(false);
      });
  };

  function currentSelectedRows(value: any) {
    setSelectedRows(value.selectedRows);
  }

  const onSearchUpdate = useCallback((term: string) => {
    setSearchQuery(term);
  }, []);

  function clearAndClose() {
    form.reset();
    setOpenApprove(false);
    setOpenReject(false);
  }

  function onChange(name: any, value: any): void {
    form.set(Form.target.VALUE, [name, value]);
  }

  const onChangeStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setRequestStatus(value);
    setSelectedRows([]);
    //setPage(1);
    //console.log("page: " + page);
  };

  function renderTitle() {
    switch (requestStatus) {
      case "APPROVAL IN-PROGRESS":
        return (
          <Typography variant="h6">Requests Pending for Approval</Typography>
        );
      case "APPROVED":
        return <Typography variant="h6">Approved Requests</Typography>;
      case "REJECTED":
        return <Typography variant="h6">Rejected Requests</Typography>;
      default:
        return <Typography variant="h6">Pending for Approval</Typography>;
    }
  }

  let submitText = isSubmitting ? "Please wait..." : "Approve";
  let rejecttText = isSubmitting ? "Please wait..." : "Reject";

  return (
    <Box mt={2}>
      <Grid item xs={12}>
        {renderTitle()}
      </Grid>
      <Grid container direction="row" spacing={2}>
        <Grid item container xs={12} justify="flex-end">
          <Grid item xs={3}>
            <Search
              onSearchUpdate={onSearchUpdate}
              placeholder={"Search by Reference #"}
            ></Search>
          </Grid>
        </Grid>
        <Grid item container xs={12} justify="flex-end">
          <FormControl>
            <RadioGroup
              row
              name="controlled-radio-buttons-group"
              value={requestStatus}
              onChange={onChangeStatus}
            >
              <FormControlLabel
                value="APPROVAL IN-PROGRESS"
                control={<Radio />}
                label="APPROVAL IN-PROGRESS"
              />
              <FormControlLabel
                value="APPROVED"
                control={<Radio />}
                label="APPROVED"
              />
              <FormControlLabel
                value="REJECTED"
                control={<Radio />}
                label="REJECTED"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        {requestStatus === "APPROVAL IN-PROGRESS" ? (
          <Grid item xs={8}>
            <Button
              disabled={selectedRows.length > 0 ? false : true}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (selectedRows.length > 0) {
                  setOpenReject(true);
                }
              }}
            >
              Reject Request
            </Button>{" "}
            &nbsp;
            <Button
              disabled={selectedRows.length > 0 ? false : true}
              variant="contained"
              color="primary"
              onClick={() => {
                if (selectedRows.length > 0) {
                  setOpenApprove(true);
                }
              }}
            >
              Approve Request
            </Button>
          </Grid>
        ) : null}
      </Grid>
      <DataTable
        columns={columns}
        data={forApprovals}
        highlightOnHover
        pagination
        paginationServer
        paginationTotalRows={total}
        paginationPerPage={perPage}
        onSort={handleSort}
        sortServer
        persistTableHead
        pointerOnHover
        clearSelectedRows={clearSelectedRows}
        onChangePage={(page) => setPage(page)}
        paginationRowsPerPageOptions={[10]}
        paginationDefaultPage={1}
        paginationResetDefaultPage={resetPaginationPage}
        onChangeRowsPerPage={(newPerPage: number, page: number) =>
          setPerPage(newPerPage)
        }
        selectableRows
        onSelectedRowsChange={(e) => currentSelectedRows(e)}
        data-tag="allowRowEvents"
        progressPending={isLoading}
        progressComponent={<LinearIndeterminate />}
        onRowClicked={(data: any) => {
          history.push(`/dashboard/requests/${data.encryptId}`, {
            readonlyAttestation: true,
            prevPage: "APPROVE",
          });
        }}
      />
      <ConfirmModal
        isOpen={openApprove}
        title="Approve Request Confirmation"
        closeModal={() => clearAndClose()}
        size="sm"
      >
        <Form>
          <Form.Textbox
            label="Comment"
            name="comment"
            onChange={onChange}
            size={12}
            maxLength={200}
            error={null}
            value={form.values.comment}
            placeholder="Enter here"
          />
          <Box textAlign="right" mt={4}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => clearAndClose()}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="button"
              onClick={onSubmitApproval}
              style={{ marginLeft: "40px" }}
              disabled={isSubmitting}
            >
              {submitText}
            </Button>
          </Box>
        </Form>
      </ConfirmModal>

      <ConfirmModal
        isOpen={openReject}
        title="Reject Request Confirmation"
        closeModal={() => clearAndClose()}
        size="sm"
      >
        <Form>
          <Form.Textbox
            label="Comment"
            name="commentReject"
            onChange={onChange}
            size={12}
            maxLength={200}
            error={null}
            required={true}
            value={form.values.commentReject}
            placeholder="Enter here"
          />
          <Box textAlign="right" mt={4}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => clearAndClose()}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="button"
              onClick={onSubmitReject}
              style={{ marginLeft: "40px" }}
              disabled={isSubmitting}
            >
              {rejecttText}
            </Button>
          </Box>
        </Form>
      </ConfirmModal>
    </Box>
  );
};
